module.exports = __webpack_public_path__ + "img/Altruvest Official Logo.ae11c913.svg";